// ⚠️ 2026-09-29 审计（事件级全量扫描）：ANALYSIS_COMMAND_FAILED('analysis_command_failed')
// 自注册以来从未有过任何调用点（hook trackAnalysisCommandFailed 同为死代码，一并删除）。
// 各分析命令的失败已由**具体事件**承载 reason_code / http_status：
//   - runs 执行失败 → result_pending_execution_completed
//   - preflight 失败 → upload_preflight_completed(action_status=failed)
//   - retry 失败 → result_pending_retry_completed
//   - subject 回刷失败 → result_pending_subject_refresh_completed
// 若未来需要通用命令失败事件，须先在调用方（analysisCommands）接线，勿只恢复注册表。
export const ANALYSIS_EVENTS = Object.freeze({});
